<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Manage Section Language Settings
    </div>

    <div class="page-attributes d-flex justify-content-end p-1">
      <button type="button" class="btn btn-primary btn-action" (click)="backUrl()">
        <i class="fa fa-home"></i> Home
      </button>
    </div>

    <div class="card-header nocollapse bg-info col-md-12 msg-container" *ngIf="successOrFailureMessage">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <b>{{successOrFailureMessage}}</b>
    </div>

    <div class="card-body">
      <form [formGroup]="sectionLanguageForm" autocomplete="off">
        <div class="row mb-3 align-items-center">
          <label class="col-md-2 col-form-label fw-semibold">Section Name</label>
          <div class="col-md-8">
            <span class="form-control-plaintext">{{ sectionName }}</span>
          </div>
        </div>
        <div class="row mb-3 align-items-center">
          <label for="languageId" class="col-md-2 col-form-label fw-semibold">
            Language <span class="text-danger">*</span>
          </label>
          <div class="col-md-4">
            <!--<select id="languageId" class="form-select form-select-sm"
          formControlName="languageId">
    <option value="">--Select--</option>
    <option *ngFor="let item of languageList" [value]="item.languageId">
      {{item.name}}
    </option>
  </select>-->
            <kendo-dropdownlist id="languageId"
                                [data]="languageList"
                                textField="name"
                                valueField="languageId"
                                formControlName="languageId"
                                [filterable]="true"
                                filter="contains"
                                [defaultItem]="{ languageId: 0, name: '--Select--' }"
                                [valuePrimitive]="true"
                                [popupSettings]="{ width: '300px' }">
            </kendo-dropdownlist>
            <small class="text-danger"
                   *ngIf="sectionLanguageForm.get('languageId')?.invalid && sectionLanguageForm.get('languageId')?.touched">
              Language is required
            </small>
          </div>
        </div>
        <div class="row mb-3 align-items-center">
          <kendo-editor formControlName="sectionDescription"
                        [resizable]="true"
                        [style.height.px]="250">
          </kendo-editor>
          <!--<label for="languageText" class="col-md-2 col-form-label fw-semibold">
    Description <span class="text-danger">*</span>
  </label>-->
          <!--<div class="col-md-8">
    <textarea id="languageText" class="form-control form-control-sm"
              formControlName="languageText" rows="3"></textarea>
    <small class="text-danger"
           *ngIf="sectionLanguageForm.get('languageText')?.invalid && sectionLanguageForm.get('languageText')?.touched">
      Description is required
    </small>
  </div>-->
        </div>
        <div class="mb-3">
          <button type="button"
                  class="btn btn-primary btn-action"
                  [disabled]="sectionLanguageForm.invalid || isDisabled"
                  (click)="saveSectionLanguage()">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      </form>

      <!-- ISG Grid replacing ag-grid-angular -->
      <isg-grid [rowData]="questionLanguageSettingsList"
                [columnDefs]="columnDefs"
                [config]="gridConfig"
                (gridReady)="onGridReady($event)">
      </isg-grid>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal (ng-bootstrap style) -->
<ng-template #deleteLanguageModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Delete Section Language Confirmation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to delete this section language?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()">
      <i class="fa fa-times"></i> Close
    </button>
    <button type="button" class="btn btn-danger btn-modal" (click)="modal.close(); deleteSurveyMappingId()">
      <i class="fa fa-trash"></i> Delete
    </button>
  </div>
</ng-template>
